import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const MAX_HOURS = 23 // stored in a Postgres `time` column
const MAX_MINUTES = 59

const fieldClass = 'block w-20 p-2 border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:outline-none'

const clamp = (value, max) => Math.min(Math.max(Math.trunc(Number(value)) || 0, 0), max)
const pad = number => String(number).padStart(2, '0')

// An amount of time as "HH:MM". A native time input is an hour of the day: in a
// 12-hour locale it adds AM/PM, and "02:00 PM" would be saved as a 14-hour span.
const DurationInput = ({ name, value = '', onChange }) => {
  const { t } = useTranslation()
  const [hours = 0, minutes = 0] = String(value).split(':').map(Number)
  const isEmpty = !hours && !minutes

  const update = (nextHours, nextMinutes) => onChange({
    target: { name, value: nextHours || nextMinutes ? `${pad(nextHours)}:${pad(nextMinutes)}` : '' }
  })

  return (
    <div className='mt-1 flex items-center gap-2'>
      <input
        type='number'
        min={0}
        max={MAX_HOURS}
        value={isEmpty ? '' : hours}
        onChange={event => update(clamp(event.target.value, MAX_HOURS), minutes)}
        aria-label={t('common.duration.hours')}
        className={fieldClass}
      />
      <span className='text-sm'>{t('common.duration.hoursShort')}</span>
      <input
        type='number'
        min={0}
        max={MAX_MINUTES}
        value={isEmpty ? '' : minutes}
        onChange={event => update(hours, clamp(event.target.value, MAX_MINUTES))}
        aria-label={t('common.duration.minutes')}
        className={fieldClass}
      />
      <span className='text-sm'>{t('common.duration.minutesShort')}</span>
    </div>
  )
}

DurationInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

export default DurationInput
